module.exports = __webpack_public_path__ + "img/job-vacancies.02871ec4.svg";